import { backendNode, backendPy } from "System/system";
import { partitionFiles } from "Redux/collections/actions";
import store from "System/reduxStore";

// -------------------------------------------------------
// -------------------------------------------------------
const attachDir = (path, tag) => async (dispatch) => {
  const project = store.getState().project;
  const repository = project.repository
    ? JSON.parse(JSON.stringify(project.repository))
    : {};

  const result = await backendPy("files", "get_dir", { path, tag });
  if (result.data) {
    const { dir, flatFiles } = result.data;
    dispatch({ type: "ATTACH_DIR_TO_PROJECT", dir, flatFiles });

    // attach new files to repository
    flatFiles.forEach((file) => {
      repository[file.id] = file;
    });
    const allFlatFiles = Object.values(repository);
    dispatch(partitionFiles(allFlatFiles));
  }
};

// -------------------------------------------------------
// -------------------------------------------------------
const getUpdatedDirs = async (path) => {
  const data = store.getState();
  const { converters } = data.conversions;
  const extensions = Object.keys(converters);
  const result = await backendPy("files", "get_dir", { path, tag: "scan" });
  if (!result.data) return null;
  const { flatFiles } = result.data;
  const files = { all: flatFiles };
  extensions.forEach((ext) => {
    files[ext] = flatFiles.filter((x) => x.ext === ext.toUpperCase());
  });
  return files;
};

// -------------------------------------------------------
// -------------------------------------------------------
export const startUnzipping = (startDir, tag) => async (dispatch) => {
  let files;
  const data = store.getState();
  const { converters } = data.conversions;
  const extensions = Object.keys(converters);
  dispatch({ type: "CONVERTERS_COMPLETE_STEP", ext: "upload" });

  dispatch({ type: "SET_CHECKIN_PROGRESS", ext: "traverse" });
  dispatch({ type: "SET_SCANNING", scanning: true });
  files = await getUpdatedDirs(startDir);
  dispatch({ type: "SET_SCANNING", scanning: false });
  dispatch({ type: "CONVERTERS_COMPLETE_STEP", ext: "traverse" });

  dispatch(updateConversionStats(files, extensions));
  dispatch({ type: "SET_CHECKIN_PROGRESS", ext: "zip" });
  await dispatch(unzipAll(files["all"]));
  dispatch({ type: "CONVERTERS_COMPLETE_STEP", ext: "zip" });

  const converterFuncs = {
    xls: xlsx2csv,
    xlsx: xlsx2csv,
  };

  dispatch({ type: "SET_SCANNING", scanning: true });
  files = await getUpdatedDirs(startDir);

  dispatch({ type: "SET_SCANNING", scanning: false });
  dispatch(updateConversionStats(files, extensions));

  for (var ii = 3; ii < extensions.length - 1; ii++) {
    console.log(extensions[ii]);
    const thisExtension = extensions[ii];
    const theseFiles = files[thisExtension];
    for (var cc = 0; cc < theseFiles.length; cc++) {
      dispatch({
        type: "SET_CONVERSION_PROGRESS",
        pointer: cc + 1,
        ext: thisExtension,
      });
      const thisFile = theseFiles[cc];
      await converterFuncs[thisExtension](thisFile);
    }
    dispatch({ type: "CONVERTERS_COMPLETE_STEP", ext: thisExtension });
    if (theseFiles.length > 0) {
      dispatch({ type: "SET_SCANNING", scanning: true });
      files = await getUpdatedDirs(startDir);
      dispatch({ type: "SET_SCANNING", scanning: false });
    }
    dispatch(updateConversionStats(files, extensions));
  }
  const csvFiles = files.csv;
  for (var dd = 0; dd < csvFiles.length; dd++) {
    dispatch({
      type: "SET_CONVERSION_PROGRESS",
      pointer: dd,
      ext: "csv",
    });
    await encodeUtf8(csvFiles[dd]);
  }

  dispatch(attachDir(startDir, tag));
  dispatch({ type: "SHOW_HIDE_CONVERTERS", showConverters: false });
  //dispatch({ type: "SET_ACTIVE_TAB", current: "files", ancestor: "root" });
};

// -------------------------------------------------------
// -------------------------------------------------------
export const showHideConverters = (showConverters) => ({
  type: "SHOW_HIDE_CONVERTERS",
  showConverters,
});

// -------------------------------------------------------
// -------------------------------------------------------
const updateConversionStats = (files, extensions) => (dispatch) => {
  const counts = {};

  for (var ii = 0; ii < extensions.length; ii++) {
    const thisExtension = extensions[ii];
    counts[thisExtension] = files[thisExtension].length;
  }
  dispatch({ type: "SET_CONVERSION_STATS", counts });
};

// -------------------------------------------------------
// -------------------------------------------------------
export const unzipAll = (flatFiles) => async (dispatch) => {
  const zipFiles = flatFiles.filter((x) => x.ext === "ZIP");
  dispatch({ type: "SET_ZIP_STATS", nZips: zipFiles.length });

  const newZips = [];
  let pointer = 0;
  for (var zipFile of zipFiles) {
    pointer++;
    dispatch({
      type: "SET_CONVERSION_PROGRESS",
      pointer,
      ext: "zip",
    });

    const result = await backendPy("files", "unzip_file", zipFile);
    const { data } = result;
    const remainingZipFiles = data.flatFiles.filter((x) => x.ext === "ZIP");
    if (remainingZipFiles.length) {
      for (var newZipFile of remainingZipFiles) {
        newZips.push(newZipFile);
      }
    }
  }
  if (newZips.length) {
    await dispatch(unzipAll(newZips));
  }
};

// -------------------------------------------------------
// -------------------------------------------------------
export const xls2xlsx = async (file) => {
  await backendNode("files", "xls2xlsx", {
    xlsFile: file.name,
    xlsxFile: file.name.replace(/\./g, "_") + ".xlsx",
    path: file.path,
  });
};

// -------------------------------------------------------
// -------------------------------------------------------
export const xlsm2xlsx = async (file) => {
  await backendNode("files", "xlsm2xlsx", {
    xlsmFile: file.name,
    xlsxFile: file.name.replace(/\./g, "_") + ".xlsx",
    path: file.path,
  });
};

// -------------------------------------------------------
// -------------------------------------------------------
export const tab2csv = async (file) => {
  await backendNode("files", "tab2csv", {
    tabFile: file.name,
    csvFile: file.name.replace(/\./g, "_") + ".csv",
    path: file.path,
  });
};

// -------------------------------------------------------
// -------------------------------------------------------
export const dat2csv = async (file) => {
  await backendPy("files", "dat2csv", {
    datFile: file.name,
    csvFile: file.name.replace(/\./g, "_") + ".csv",
    path: file.path.replace(/\./g, ""),
  });
  await backendNode("files", "eraseFile", {
    file: file.name,
    path: file.path,
  });
};

// -------------------------------------------------------
// -------------------------------------------------------
export const txt2csv = async (file) => {
  await backendPy("files", "txt2csv", {
    txtFile: file.name,
    csvFile: file.name.replace(/\./g, "_") + ".csv",
    path: file.path.replace(/\./g, ""),
  });
  await backendNode("files", "eraseFile", {
    file: file.name,
    path: file.path,
  });
};


// -------------------------------------------------------
// -------------------------------------------------------
export const xlsx2csv = async (thisFile) => {
  let file = thisFile.name;
  let path = thisFile.path;
  await backendPy("files", "xlsx2csv", { file, path });
};

// -------------------------------------------------------
// -------------------------------------------------------
export const xlsx2csv__ = async (thisFile) => {
  const isLocal = window.location.href.slice(7, 16) === "localhost";
  let file = thisFile.name;
  let path = thisFile.path;
  await backendNode("files", "xlsx2csvLibre", { file, path, isLocal });
  await backendNode("files", "eraseFile", { file, path });
};

// -------------------------------------------------------
// -------------------------------------------------------
export const encodeUtf8__ = async (file) => {
  let csvfile = file.name;
  let path = file.path;
  await backendNode("files", "encodeUtf8", { csvfile, path });
};

// -------------------------------------------------------
// -------------------------------------------------------
export const encodeUtf8 = async (thisFile) => {
  let file = thisFile.name;
  let path = thisFile.path;
  await backendPy("files", "encode_utf8", { file, path });
};

// -------------------------------------------------------
// -------------------------------------------------------
export const socan2csv = async (file) => {
  await backendPy("files", "socan2csv", {
    fromFile: file.name,
    toFile: file.name.replace(/\./g, "_") + ".csv",
    path: file.path.replace(/\./g, ""),
  });
  await backendNode("files", "eraseFile", {
    file: file.name,
    path: file.path,
  });
};

// -------------------------------------------------------
// -------------------------------------------------------
export const welk2csv = async (file) => {
  await backendPy("files", "welk2csv", {
    fromFile: file.name,
    toFile: file.name.replace(/\./g, "_") + ".csv",
    path: file.path.replace(/\./g, ""),
  });
  await backendNode("files", "eraseFile", {
    file: file.name,
    path: file.path,
  });
};

// -------------------------------------------------------
// -------------------------------------------------------
export const hipgnosify = (file, parser) => async (dispatch) => {
  await backendPy("files", "hipgnosify", {
    file: file.name,
    path: file.path.replace(/\./g, ""),
    cut: file.cut,
    parser,
  });
};